@if (calculatingPrice()) {
  <div class="text-center offer-detail__price-calculating">
    <h4 *appApplyIfNotEmpty="translationService.getTranslation('wait_while_pricecalculation')"
        [innerHTML]="translationService.getTranslation('wait_while_pricecalculation')"></h4>
<!--    <app-loading-spinner [type]="'small'"></app-loading-spinner>-->
  </div>
} @else {
  <div class="text-center offer-detail__price-calculated">
    <h4 class="text-center"
        *appApplyIfNotEmpty="translationService.getTranslation(hasPriceCalculationError() ? 'error_price_calculation' : 'price_calculated')"
        [innerHTML]="translationService.getTranslation(hasPriceCalculationError() ? 'error_price_calculation' : 'price_calculated')">
    </h4>
  </div>
}
@if (creatingOrder()) {
  <div class="text-center offer-detail__order-creating">
    <h4 *appApplyIfNotEmpty="translationService.getTranslation('wait_while_orderCreating')"
        [innerHTML]="translationService.getTranslation('wait_while_orderCreating')"></h4>
    <app-loading-spinner [type]="'small'"></app-loading-spinner>
  </div>
}

<!-- Nur am Ende anzeigen, da die Internals dieses Blocks ein ziemliches Feuerwerk zünden -->
<!--@if (stepper.selectedIndex == stepper.steps.length - 1) {-->
  <div class="col-12 mt-4">
    <div class="row summary">
      @for (block of getVisibleSummaryBlocks(); track $index; let idx = $index) {
        <div class="p-1" [ngClass]="isLastBlockFullWidth(idx) ? 'col-12' : 'col-12 col-lg-6'">
          <div class="p-3">
            <div class="summary__block-header">
              <b>{{ getBlockTitle(block) }}</b>
              <!--Die Lieferadresse ist hier nie aenderbar: sie bestimmt den Preis und wird
                  ausschliesslich im Adress-Step erfasst.-->
              @if (isDigitalOffer() && isBillingAddressEditable() && block === 'billing') {
                <button type="button"
                        class="summary__billing-edit-btn"
                        (click)="openBillingAddressEditor()"
                        [attr.aria-label]="translationService.getTranslation('address_billing')">
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
              }
            </div>
            @if (block === 'price' && calculatingPrice()) {
              <div class="price_spinner" style="position: absolute;">
                <app-loading-spinner [type]="'small'"/>
              </div>
            }
            <div [innerHTML]="getBlockContent(block)" class="mt-2"></div>
          </div>
        </div>
      }
    </div>
  </div>

<div class="mt-md-5 mt-3">
  <!--Bei digitalen Abos gibt es keinen expliziten Address-step. Hier wird die Adresse abgefragt,
      falls wir keine gefunden haben (vom bestehenden Nutzer oder aus PayPal). Ob die Maske offen
      ist, entscheidet ausschliesslich showBillingAddressEditor() - bei einer Online-Zahlart klappt
      sie nicht von selbst auf, sondern erst auf den Stift.-->
  @if (isDigitalOffer() && isBillingAddressEditable() && showBillingAddressEditor()) {
    <app-hup-subscription-address
      [showActivateCheckbox]="false"
      [addressType]="translationService.getTranslation('address_billing')"
      [activateCheckboxText]="'optional_address_billing'"
      [controlGroup]="billingAddressGroup">
    </app-hup-subscription-address>
  }
</div>
  <div class="col-12">
    <!--
    Die Offer-Card ist an dieser Stelle zugegebenermaßen etwas oversized, um lediglich die Opt-Ins und den
    Bestell-Button anzuzeigen. Die beiden Elemente sind sehr mit der Offer-Card verwoben.
    ToDo: Opt-Ins/Bestell-Button aus OfferCard herauslösen
     -->
    <app-offer-card
      [showOnlyOptIns]="true"
      [offer]="offer()"
      [showOnOfferPage]="false"
      [stepper]="stepper"
      [deliveryAddress]="selectedDeliveryAddress()"
      [billingAddress]="selectedBillingAddress()"
      [bonusAddress]="selectedBonusAddress()"
      [paymentCode]="selectedPaymentMethod()"
      [paymentFrequency]="selectedPaymentFrequency()"
      [startDate]="selectedStartDate()"
      [prices]="offerPrice()"
      [creatingOrder]="creatingOrder()"
      [isCalculatingPrice]="calculatingPrice()"
      [onlinePayment]="showOnlinePayment()"
      (save)="onCompleteOrder($event)"
      [disclaimerMode]="disclaimerMode"
      [optionalBillingAddressValid]="optionalBillingAddressValid()">
    </app-offer-card>
  </div>
<!--}-->

<!-- Das ist wenn die Bezahlung im letzten Schritt abgeschlossen wird -->
<!-- Bestellung mit PayPal ausführen -->
<!--@if (showOnlinePayment && agbChecked()) {-->
<!--  <br>-->
<!--  <app-onlinepayment [subscriptionStartTime]="selectedStartDate()" class="offer-detail__online-payment"/>-->
<!--}-->
